<script setup lang="ts">
// @ts-nocheck
import {useCartStore} from "../../stores/cart";
import {Loader2Icon} from 'lucide-vue-next'
import {ref} from "vue";
import {label} from "../../mixins/translations";
import {TooltipProvider} from "reka-ui";
import Tooltip from "../../../backend/ui/tooltip/Tooltip.vue";

const cartStore = useCartStore();
const open = ref(false)

interface Props {
    catalogUrl: string,
    cartUrl: string,
}

defineProps<Props>()

</script>

<template>
    <TooltipProvider delay-duration="200">
        <Tooltip :content="label('site.cart.header.title')">
            <a :href="cartUrl" class="relative flex rounded-lg h-9 w-9 lg:h-12 lg:w-12 justify-center items-center border border-gray-200">
                <div
                    class="absolute flex w-7 h-7 bg-[#88c87f] text-white border-4 border-white font-bold -top-3 -right-3 rounded-full text-xs text-center leading-3 items-center justify-center">
                    <Loader2Icon class="size-3 animate-spin text-primary-foreground" v-if="cartStore.isLoading"/>
                    <span v-else>{{ cartStore.itemCount }}</span>
                </div>
                <svg class="h-6 w-6 lg:h-7 lg:w-7" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="8" cy="21" r="1"/><circle cx="19" cy="21" r="1"/><path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"/></svg>
            </a>
        </Tooltip>
    </TooltipProvider>
</template>
